// extracted by mini-css-extract-plugin
export default {"card":"styles_card__dXdR+","content":"styles_content__Ma3HT","icon":"styles_icon__XUfFB","inlineText":"styles_inlineText__hYA5l","removeBookingBtn":"styles_removeBookingBtn__MtOVv"};